<div class="grid ">
    <div class="col-12">
        <div class="card" *ngIf="!verificarPermissao('PERM_DETALHAR_USUARIO_EMPRESA')">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
        <div class="card" *ngIf="verificarPermissao('PERM_DETALHAR_USUARIO_EMPRESA')">
            <form #form="ngForm" name="form" novalidate>
                <div class="formgroup" >
                    <div class="flex justify-content-center" *ngIf="loading">
						<p-progressSpinner></p-progressSpinner>
					</div>
                    <div *ngIf="messagemVisivel" class="w-full mb-5">
                        <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
                    </div>
                    <div class="p-fluid p-formgrid grid pt-3 px-3" *ngIf="usuario && !loading">
                        <div class="col-12 card-simple mb-3">
							<div class="p-fluid p-formgrid grid">
                                <div class="col-12 md:col-6 xl:col-4">
                                    <label class="label-superior">Nome</label>
                                    <label class="label-inferior" >{{ usuario.nome }}</label>
                                </div>
                                <div class="col-12 md:col-6 xl:col-4">
                                    <label class="label-superior">E-mail</label>
                                    <label class="label-inferior" >{{ usuario.email }}</label>
                                </div>
                                <div class="col-12 md:col-6 xl:col-4">
                                    <label class="label-superior">CPF</label>
                                    <label class="label-inferior" >{{ usuario.cpf | cpfFormat }}</label>
                                </div>
                            </div>
                        </div>

                        <div class="w-full mb-5">
                            <div class="col-12">
                                <h5>Permissões Adicionadas</h5>
                            </div>
                            <p-treeTable [value]="categoriasTreeTableSalvas" [columns]="colunasTreeTableSalvas">
                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th *ngFor="let col of columns">
                                            {{col.header}}
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
                                    <tr>
                                        <td *ngFor="let col of columns; let i = index">
                                            <p-treeTableToggler [rowNode]="rowNode" *ngIf="i == 0"></p-treeTableToggler>
                                            {{rowData[col.field]}}
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-treeTable>

                        </div>
                        
                    </div>
                    <div class="p-fluid p-formgrid grid justify-content-end" *ngIf="!loading">
                        <div class="col-12 md:col-4 flex justify-content-end">
                            <button type="button"  pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined md:w-9rem" routerLink="/apps/usuario-empresa"></button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>